/* CertiClear product page scripts — loaded by sections/main-product.liquid.
   Scope: the variant-aware buy box (size ladder, price, media, URL), the
   subscription selector with actual allocation pricing, the read-only
   shipping estimator and the sticky bar's product-form proxies.

   Load order: assets/global.js is deferred from layout/theme.liquid's <head>
   and this file is deferred from the section, so document order guarantees
   window.CertiClearCart already exists when this runs. */

(function () {
  'use strict';

  /* Product page thumbnail switcher */
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('[data-thumbnail-src]');
    if (!thumb) return;
    var main = document.querySelector('[data-main-product-image]');
    if (!main) return;
    main.src = thumb.getAttribute('data-thumbnail-src');
    main.srcset = '';
    main.alt = thumb.getAttribute('data-thumbnail-alt') || '';
    thumb.closest('.product__thumbnails')
      .querySelectorAll('button')
      .forEach(function (b) { b.removeAttribute('aria-current'); });
    thumb.setAttribute('aria-current', 'true');
  });

  /* ---------------- Variant-aware buy box ---------------- */

  /* The size ladder can point at a sibling PRODUCT, so the current selection —
     not the page's own product — is the source of truth for the whole buy box. */
  var currentVariant = null;

  function formatMoney(cents, format) {
    var formatString = format || '${{amount}}';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var cents2 = parts[1] ? decimal + parts[1] : '';
      return dollars + cents2;
    }
    var match = formatString.match(placeholderRegex);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function formatWeight(lbs) {
    return (Math.round(lbs * 10) / 10).toFixed(1) + ' lb';
  }


  function getVariantData() {
    var script = document.querySelector('[data-variant-data]');
    if (!script) return { variants: [], format: '${{amount}}' };
    if (!script._parsed) {
      try {
        script._parsed = JSON.parse(script.textContent);
      } catch (e) {
        script._parsed = [];
      }
      script._format = script.getAttribute('data-money-format') || '${{amount}}';
    }
    return { variants: script._parsed, format: script._format };
  }

  function findVariant(id) {
    var data = getVariantData();
    for (var i = 0; i < data.variants.length; i++) {
      if (String(data.variants[i].id) === String(id)) return data.variants[i];
    }
    return null;
  }


  /* Confirmed device-local pool volume, schema v2, written by calculator.js.
     Legacy inferred tablet values are never used. */

  function poolProfile() {
    var raw = null;
    try {
      raw = window.localStorage.getItem('cc_pool');
    } catch (e) {
      return null;
    }
    if (!raw) return null;
    var profile;
    try {
      profile = JSON.parse(raw);
    } catch (e) {
      return null;
    }
    if (!profile || profile.schema_version !== 2) return null;
    var gallons = profile.gallons;
    if (!Number.isSafeInteger(gallons) || gallons < 1000 || gallons > 1000000) return null;
    return { gallons: gallons };
  }

  /* Carry the pool profile onto the order as hidden line-item properties.
     The leading underscore keeps them out of the customer-facing cart while
     admin, the order export and Klaviyo still see them. Never clobber a
     property another feature already put on the form. */
  function applyPoolProperties(form) {
    if (!form) return;
    // Drop only fields owned by this feature, including stale inferred doses.
    form.querySelectorAll('[data-pool-property="1"]').forEach(function (field) { field.remove(); });
    var profile = poolProfile();
    if (!profile) return;

    var fields = [
      { name: 'properties[_Pool gallons]', value: String(profile.gallons) }
    ];

    fields.forEach(function (field) {
      var existing = form.querySelector('[name="' + field.name + '"]');
      if (existing) {
        /* Only refresh the inputs we own — leave anything else alone */
        if (existing.getAttribute('data-pool-property') === '1') existing.value = field.value;
        return;
      }
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = field.name;
      input.value = field.value;
      input.setAttribute('data-pool-property', '1');
      form.appendChild(input);
    });
  }

  /* F0: no dosing or shipment schedule inferred from pool volume/shipping mass.
     B2 will use approved pack contents, actual receipt and observed consumption. */
  function updateCadenceHint(form) {
    var hint = form.querySelector('[data-cadence-hint]');
    if (!hint) return;
    hint.hidden = true;
    hint.textContent = '';
  }

  /* Deterministic primary plan — never "whatever the app returned first" */
  function cheapestAlloc(allocs) {
    return allocs.slice().sort(function (a, b) { return a.price - b.price; })[0];
  }

  /* One visible purchase choice owns the price, summary and both buy buttons. */
  function syncSubscribeSummary(form) {
    if (!form) return;
    var summary = form.querySelector('[data-subscribe-summary]');
    var subOption = form.querySelector('[data-subscribe-option]');
    var subRadio = form.querySelector('[data-subscribe-option] [data-selling-plan-toggle]');
    var format = getVariantData().format;
    var variant = currentVariant;
    var allocs = (variant && variant.selling_plan_allocations) || [];
    var select = form.querySelector('[data-selling-plan-select]');
    var chosen = null;
    for (var i = 0; i < allocs.length; i++) {
      if (select && String(allocs[i].selling_plan_id) === String(select.value)) chosen = allocs[i];
    }
    if (!select && allocs.length) chosen = cheapestAlloc(allocs);
    if (subOption) {
      var price = subOption.querySelector('[data-sub-price]');
      var save = subOption.querySelector('[data-sub-save]');
      var difference = chosen && variant ? variant.price - chosen.price : 0;
      if (price) price.textContent = chosen ? formatMoney(chosen.price, format) : '';
      if (save) save.textContent = difference > 0 ? '(save ' + formatMoney(difference, format) + ')' : '';
    }
    var subscribed = !!(subRadio && subRadio.checked);
    var selected = form.querySelector('[data-selling-plan-toggle]:checked');
    var required = form.getAttribute('data-requires-selling-plan') === 'true';
    var missingChoice = form.hasAttribute('data-product-purchase') && (!selected || !selected.checked);
    var valid = !missingChoice && (subscribed ? !!chosen : !required);
    if (select) select.disabled = !subscribed;
    var label = subscribed
      ? (chosen ? 'Subscription — ' + formatMoney(chosen.price, format) + ' per order' +
        (chosen.name ? ' · ' + chosen.name : '') : 'Choose an available subscription plan')
      : (valid ? 'One-time purchase' : 'Choose a purchase type');
    if (summary) {
      summary.textContent = label;
      summary.classList.toggle('is-active', subscribed && valid);
    }
    if (!variant) return;
    var effectivePrice = valid ? (subscribed ? chosen.price : variant.price) : null;
    var priceText = effectivePrice == null ? 'Select purchase option' : formatMoney(effectivePrice, format);
    var mainPrice = document.querySelector('[data-variant-price]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    if (mainPrice) mainPrice.textContent = priceText;
    if (stickyPrice) stickyPrice.textContent = priceText + (subscribed && valid ? ' / order' : '');
    var perlb = document.querySelector('[data-variant-perlb]');
    if (perlb) perlb.textContent = effectivePrice != null && variant.weight_in_lbs > 0
      ? formatMoney(Math.round(effectivePrice / variant.weight_in_lbs), format) + '/lb' : '';
    var compare = document.querySelector('[data-variant-compare]');
    if (compare) compare.textContent = valid && !subscribed && variant.compare_at_price > variant.price
      ? formatMoney(variant.compare_at_price, format) : '';
    var blocked = !variant.available || !valid || !!form.getAttribute('data-offer-error') ||
      form.getAttribute('data-purchase-ready') === 'false';
    var submit = form.querySelector('[type="submit"]');
    var sticky = document.querySelector('[data-sticky-buy-proxy]');
    [submit, sticky].forEach(function (button) {
      if (!button || button.hasAttribute('data-cart-pending')) return;
      button.disabled = blocked;
      if (button.hasAttribute('data-cart-feedback')) return;
      button.textContent = !variant.available ? (button.getAttribute('data-sold-text') || 'Sold out')
        : !valid ? 'Choose purchase type'
        : subscribed ? 'Add subscription to cart' : 'Add one-time purchase';
    });
  }

  /* Seal can replace the theme's hidden input after page load. Always resolve
     the native field again; never create a second, conflicting selling_plan. */
  function sellingPlanInput(form) {
    return form.querySelector('[name="selling_plan"]') || form.querySelector('[data-selling-plan-input]');
  }

  /* Resolve purchase intent from the visible controls, never from the app default. */
  function syncSellingPlan(form) {
    if (!form) return;
    var hidden = sellingPlanInput(form);
    var toggle = form.querySelector('[data-selling-plan-toggle]:checked');
    var select = form.querySelector('[data-selling-plan-select]');
    var plan = toggle && toggle.checked && toggle.value !== '' ? (select ? select.value : toggle.value) : '';
    // The visible theme controls own purchase intent, including explicit URLs.
    // Tell Seal via its public API so its native form field and widget agree.
    var widget = form.querySelector('.sealsubs-target-element');
    if (widget) widget.dispatchEvent(new CustomEvent('sealsubs:change_selected_selling_plan_id', {
      detail: { selling_plan_id: String(plan) }
    }));
    // Resolve once more in case the app replaced the field during the event.
    hidden = sellingPlanInput(form) || hidden;
    if (hidden) hidden.value = plan;
    syncSubscribeSummary(form);
  }

  document.addEventListener('sealsubs:subscription_widget_created', function () {
    var form = document.querySelector('.product form[data-ajax-cart]');
    if (form && currentVariant) syncSellingPlan(form);
  });
  document.addEventListener('purchase:idle', function () {
    syncSubscribeSummary(document.querySelector('.product form[data-ajax-cart]'));
  });

  document.addEventListener('change', function (event) {
    var control = event.target.closest('[data-selling-plan-toggle], [data-selling-plan-select]');
    if (!control) return;
    var form = control.closest('form');
    if (!form) return;

    if (control.matches('[data-selling-plan-select]')) {
      /* A hand-picked frequency wins over the cadence recommendation, and
         implies the shopper wants the subscription. */
      control.setAttribute('data-user-picked', '1');
      var subRadio = form.querySelector('[data-subscribe-option] [data-selling-plan-toggle]');
      if (subRadio) subRadio.checked = true;
    }
    syncSellingPlan(form);
  });

  function updateSubscription(form, variant, format) {
    var subOption = form.querySelector('[data-subscribe-option]');
    var hidden = sellingPlanInput(form);
    var oneTimePrice = form.querySelector('[data-onetime-price]');
    if (oneTimePrice && variant) oneTimePrice.textContent = formatMoney(variant.price, format);
    var required = variant.requires_selling_plan === true;
    form.setAttribute('data-requires-selling-plan', String(required));
    var oneTime = form.querySelector('[data-selling-plan-toggle][value=""]');
    var oneTimeOption = form.querySelector('[data-onetime-option]');
    if (oneTimeOption) oneTimeOption.hidden = required;
    if (oneTime) {
      oneTime.disabled = required;
      if (required) oneTime.checked = false;
    }
    if (!subOption) return;

    var allocs = (variant && variant.selling_plan_allocations) || [];
    if (!allocs.length) {
      subOption.hidden = true;
      var subRadioOff = subOption.querySelector('[data-selling-plan-toggle]');
      if (subRadioOff) subRadioOff.checked = false;
      if (oneTime) oneTime.checked = !required;
      if (hidden) hidden.value = '';
      syncSellingPlan(form);
      return;
    }

    /* Restoring available plans never opts a one-time shopper into recurring billing. */
    subOption.hidden = false;
    allocs = allocs.slice().sort(function (a, b) { return a.price - b.price; });
    var primary = allocs[0];
    var savings = variant.price - primary.price;
    var pct = variant.price > 0 ? Math.round(savings * 100 / variant.price) : 0;
    var pctEl = subOption.querySelector('[data-sub-pct]');
    var priceEl = subOption.querySelector('[data-sub-price]');
    var saveEl = subOption.querySelector('[data-sub-save]');
    if (pctEl) pctEl.textContent = pct;
    if (priceEl) priceEl.textContent = formatMoney(primary.price, format);
    if (saveEl) saveEl.textContent = savings > 0 ? '(save ' + formatMoney(savings, format) + ')' : '';

    var select = subOption.querySelector('[data-selling-plan-select]');
    if (select) {
      var prevVal = select.value;
      select.innerHTML = '';
      allocs.forEach(function (a) {
        var opt = document.createElement('option');
        opt.value = a.selling_plan_id;
        opt.textContent = a.name + ' — ' + formatMoney(a.price, format) + ' per order';
        select.appendChild(opt);
      });
      select.value = prevVal && select.querySelector('option[value="' + prevVal + '"]') ? prevVal : String(primary.selling_plan_id);
    }

    var subRadio = subOption.querySelector('[data-selling-plan-toggle]');
    if (subRadio) {
      subRadio.value = primary.selling_plan_id;
    }

    updateCadenceHint(form, variant, allocs);

    if (subRadio && subRadio.checked && hidden) {
      hidden.value = select ? select.value : primary.selling_plan_id;
    }
    syncSellingPlan(form);
  }

  /* Swap the address bar (and canonical) to the selected size without a page
     load. /cart/add.js accepts any variant id, so nothing else has to move. */
  function syncVariantUrl(variant) {
    if (!variant || !variant.url) return;
    var absolute;
    try {
      absolute = new URL(variant.url, window.location.origin).href;
    } catch (e) {
      return;
    }
    try {
      window.history.replaceState({ variantId: variant.id }, '', absolute);
    } catch (e) { /* replaceState can throw in sandboxed previews */ }
    var canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', absolute);
  }

  /* Sibling entries carry the product title, so the page identity moves too */
  function syncProductIdentity(variant) {
    if (!variant || !variant.is_product || !variant.title) return;
    var heading = document.querySelector('.product [data-product-heading]');
    if (heading) heading.textContent = variant.title;
    var stickyTitle = document.querySelector('[data-sticky-title]');
    if (stickyTitle) stickyTitle.textContent = variant.title;
    document.title = variant.title;
  }


  function applyVariant(variant) {
    if (!variant) return;
    currentVariant = variant;
    var format = getVariantData().format;
    var form = document.querySelector('.product form[data-ajax-cart]');

    if (form) {
      var idField = form.querySelector('[name="id"]');
      if (idField) idField.value = variant.id;
    }

    var priceEl = document.querySelector('[data-variant-price]');
    if (priceEl) priceEl.textContent = formatMoney(variant.price, format);

    var compareEl = document.querySelector('[data-variant-compare]');
    if (compareEl) {
      compareEl.textContent = variant.compare_at_price && variant.compare_at_price > variant.price
        ? formatMoney(variant.compare_at_price, format)
        : '';
    }

    var weightEl = document.querySelector('[data-variant-weight]');
    if (weightEl) weightEl.textContent = variant.weight_in_lbs > 0 ? '· ' + formatWeight(variant.weight_in_lbs) : '';

    var perlbEl = document.querySelector('[data-variant-perlb]');
    if (perlbEl) {
      perlbEl.textContent = variant.weight_in_lbs > 0
        ? formatMoney(Math.round(variant.price / variant.weight_in_lbs), format) + '/lb'
        : '';
    }

    if (variant.featured_media) {
      var mainImg = document.querySelector('[data-main-product-image]');
      if (mainImg && mainImg.getAttribute('src') !== variant.featured_media) {
        mainImg.src = variant.featured_media;
        mainImg.srcset = '';
      }
    }

    if (form) updateSubscription(form, variant, format);
    syncVariantUrl(variant);
    syncProductIdentity(variant);

    if (form) syncSubscribeSummary(form);

    document.querySelectorAll('[data-variant-radio]').forEach(function (r) {
      var card = r.closest('.size-card');
      if (card) card.classList.toggle('is-selected', String(r.value) === String(variant.id));
    });

    document.dispatchEvent(new CustomEvent('variant:changed', { detail: variant }));
  }

  /* Size ladder radios drive the buy box */
  document.addEventListener('change', function (event) {
    var radio = event.target.closest('[data-variant-radio]');
    if (!radio) return;
    applyVariant(findVariant(radio.value));
  });


  /* ---------------- Sticky buy bar proxies (product pages) ---------------- */

  /* Submit the real product form instead of a duplicate one */
  document.addEventListener('click', function (event) {
    var proxy = event.target.closest('[data-sticky-buy-proxy]');
    if (!proxy) return;
    event.preventDefault();
    var form = document.querySelector('.product form[data-ajax-cart]');
    if (!form) return;
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      var submit = form.querySelector('[type="submit"]');
      if (submit) submit.click();
    }
  });

  /* Second sticky proxy: the dynamic checkout button, so the 1-tap path stays
     reachable from the bar. Shopify hydrates the real button asynchronously,
     hence the click-time lookup. */
  document.addEventListener('click', function (event) {
    var proxy = event.target.closest('[data-sticky-express-proxy]');
    if (!proxy) return;
    event.preventDefault();
    var form = document.querySelector('.product form[data-ajax-cart]');
    var button = form && form.querySelector('.shopify-payment-button__button');
    if (form && (form.getAttribute('data-offer-error') ||
      (currentVariant && (currentVariant.requires_selling_plan ||
        (currentVariant.selling_plan_allocations || []).length)))) return;
    if (button) button.click();
  });

  /* A variant change must not overwrite the selected subscription's price. */
  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail;
    syncSubscribeSummary(document.querySelector('.product form[data-ajax-cart]'));
    var express = document.querySelector('[data-sticky-express-proxy]');
    if (express && variant) express.disabled = !variant.available;
  });

  /* ---------------- Shipping estimator (PDP) ---------------- */

  // An invalid incoming offer requires an explicit new selection, not a silent
  // switch to a different SKU or a one-time purchase.
  document.addEventListener('change', function (event) {
    if (!event.target.closest('[data-variant-radio], [data-selling-plan-toggle], [data-selling-plan-select]')) return;
    var form = document.querySelector('.product form[data-ajax-cart]');
    if (!form || !form.getAttribute('data-offer-error')) return;
    form.removeAttribute('data-offer-error');
    var notice = form.querySelector('[data-offer-error-message]');
    if (notice) notice.remove();
    var payment = form.querySelector('.shopify-payment-button');
    if (payment) payment.hidden = false;
    syncSubscribeSummary(form);
  });

  function initShippingEstimator() {
    var box = document.querySelector('[data-shipping-estimator]');
    if (!box) return;
    var zipInput = box.querySelector('[data-shipping-zip]');
    var button = box.querySelector('[data-shipping-check]');
    var results = box.querySelector('[data-shipping-results]');
    if (!zipInput || !button || !results) return;

    function escapeRate(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, function (character) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character];
      });
    }

    function showRates(data) {
      if (data && data.requires_items) {
        showError('Add the products you want to your cart first, then check delivery rates. Nothing was added automatically.');
        return;
      }
      var rates = (data && data.shipping_rates) || [];
      if (!rates.length) {
        results.innerHTML = '<p class="shipping-estimator__none">No delivery rates were returned for this cart and ZIP. Confirm availability at checkout or contact us.</p>';
      } else {
        var html = '<ul class="shipping-estimator__list">';
        rates.forEach(function (r) {
          var price = parseFloat(r.price) === 0 ? 'Free' : '$' + r.price;
          html += '<li><span>' + escapeRate(r.name) + '</span><strong>' + escapeRate(price) + '</strong></li>';
        });
        html += '</ul><p>Estimate for the products currently in your cart. Delivery, pickup availability and final totals are confirmed at checkout.</p>';
        results.innerHTML = html;
      }
      results.hidden = false;
    }

    function showError(message) {
      results.textContent = message;
      results.hidden = false;
    }

    button.addEventListener('click', function () {
      var zip = (zipInput.value || '').trim();
      if (!/^\d{5}(-\d{4})?$/.test(zip)) {
        showError('Enter a valid US ZIP code (e.g. 33442).');
        return;
      }
      button.disabled = true;
      button.textContent = 'Checking…';

      Promise.resolve().then(function () {
        return window.CertiClearCart.estimateShipping(zip);
      }).then(showRates).catch(function (err) {
        showError((err && err.description) || 'Could not estimate rates right now — try again in a moment.');
      }).finally(function () {
        button.disabled = false;
        button.textContent = 'Check rates';
      });
    });

    zipInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') { event.preventDefault(); button.click(); }
    });
  }

  /* Capture phase: global.js serializes properties in its own bubbling submit
     handler, so refreshing the values here guarantees the freshest profile
     (e.g. the shopper recalculated in another tab) makes it onto the line. */
  document.addEventListener('submit', function (event) {
    var form = event.target.closest('.product form[data-ajax-cart]');
    if (!form) return;
    applyPoolProperties(form);
    syncSellingPlan(form);
  }, true);

  function initProduct() {
    initShippingEstimator();

    var data = getVariantData();
    if (!data.variants.length) return;

    var checked = document.querySelector('[data-variant-radio]:checked');
    var initial = checked ? findVariant(checked.value) : data.variants[0];

    var params = new URLSearchParams(window.location.search);
    var sellingPlan = params.get('selling_plan');
    var requestedVariant = params.get('variant');
    var explicitVariant = requestedVariant ? findVariant(requestedVariant) : null;
    var target = explicitVariant || initial;
    var productForm = document.querySelector('.product form[data-ajax-cart]');
    // Optional products always start one-time unless the link explicitly names a plan.
    if (productForm && productForm.hasAttribute('data-product-purchase') && target &&
      !target.requires_selling_plan && !sellingPlan) {
      var defaultOneTime = productForm.querySelector('[data-selling-plan-toggle][value=""]');
      var defaultSubscription = productForm.querySelector('[data-subscribe-option] [data-selling-plan-toggle]');
      if (defaultSubscription) defaultSubscription.checked = false;
      if (defaultOneTime) defaultOneTime.checked = true;
    }
    var planVariant = sellingPlan && target && (target.selling_plan_allocations || []).some(function (allocation) {
      return String(allocation.selling_plan_id) === String(sellingPlan);
    }) ? target : null;
    if (target) {
      var radio = document.querySelector('[data-variant-radio][value="' + target.id + '"]');
      if (radio) radio.checked = true;
      applyVariant(target);
    }

    /* Pool profile rides along on every add-to-cart from this page */
    applyPoolProperties(productForm);

    if (planVariant && productForm) {
      var subRadio = productForm.querySelector('[data-subscribe-option] [data-selling-plan-toggle]');
      var select = productForm.querySelector('[data-selling-plan-select]');
      if (subRadio) subRadio.checked = true;
      if (select && select.querySelector('option[value="' + sellingPlan + '"]')) {
        select.value = sellingPlan;
        /* An explicit ?selling_plan= beats the cadence recommendation */
        select.setAttribute('data-user-picked', '1');
      }
      /* The choice arrived in the URL — never leave it folded away */
      var details = document.querySelector('[data-subscribe-details]');
      if (details) details.open = true;
    }

    /* Mirror the visible purchase choice into the native form and displayed price. */
    if (productForm) syncSellingPlan(productForm);
    if (productForm && ((requestedVariant && !explicitVariant) || (sellingPlan && !planVariant))) {
      productForm.setAttribute('data-offer-error', 'unavailable');
      var notice = document.createElement('p');
      notice.setAttribute('data-offer-error-message', '');
      notice.setAttribute('role', 'alert');
      notice.textContent = 'The linked purchase option is unavailable. Choose a product and purchase option before continuing.';
      productForm.appendChild(notice);
      var payment = productForm.querySelector('.shopify-payment-button');
      if (payment) payment.hidden = true;
      syncSubscribeSummary(productForm);
    }

    /* Only offer the express proxy when the real dynamic checkout button is on the page */
    var express = document.querySelector('[data-sticky-express-proxy]');
    if (express) {
      express.hidden = !(productForm && productForm.querySelector('.shopify-payment-button'));
    }
    if (productForm) {
      productForm.setAttribute('data-purchase-ready', 'true');
      var choices = productForm.querySelector('[data-subscribe-details]');
      if (choices) choices.disabled = false;
      syncSubscribeSummary(productForm);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProduct);
  } else {
    initProduct();
  }
})();
